module.exports = __webpack_public_path__ + "static/media/genisis18.d1164053.jpg";